import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';
import { styled } from '@mui/system';

// Custom styles for the Backdrop
const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 9999,
    color: '#fff',
    backgroundColor: 'rgba(0, 0, 0, 0.3)', // Dimmed transparent background
}));

// Custom CircularProgress styles
const StyledCircularProgress = styled(CircularProgress)(({ theme }) => ({
    thickness: 5, // Spinner line thickness
    width: '80px !important', // Spinner size
    height: '80px !important', // Spinner size
}));

const BlockingSpinner = ({ open }) => {
    return (
        <StyledBackdrop open={open}>
            <StyledCircularProgress />
        </StyledBackdrop>
    );
};

export default BlockingSpinner;
